<template>
  <!--渲染表单-->
  <div>
    <el-form v-if="mode === 'PC'" ref="form" class="process-form" label-position="top" :rules="rules" :model="_value">
      <div :class="{ readonly: isReadonly(item) }" v-if="showItem(item)" v-for="(item, index) in forms"
        :key="item.name + index"
        :style="{ display: item.name !== 'SpanLayout' && item.name !== 'Description' && item.name !== 'TableList' && item.name !== 'fieldlist' && item.name !== 'TextareaInput' ? 'inline-flex' : 'block', width: item.name !== 'SpanLayout' && item.name !== 'Description' && item.name !== 'TableList' && item.name !== 'fieldlist' && item.name !== 'TextareaInput' ? '50%' : '95%' }">
        <el-form-item v-if="item.name !== 'SpanLayout' && item.name !== 'Description' && item.name !== 'TableList'"
          :prop="item.id" :label="item.title">
          <form-design-render @loadings="handleLoading" :ref="item.id" v-model="_value[item.id]" :readonly="isReadonly(item)" :form-data="_value"
            :mode="mode" :config="item" />
        </el-form-item>
        <el-form-item v-else-if="item.name == 'TableList'" :prop="item.id" :label="item.title">
          <!-- {{_value[item.id]}} -->
          <form-design-render @loadings="handleLoading" :ref="item.id" v-model="_value[item.id]" :readonly="isReadonly1(item, _value[item.id])"
            :form-data="_value" :mode="mode" :config="item" :resultTableList="resultTableList" />
        </el-form-item>
        <form-design-render v-else @loadings="handleLoading" :ref="item.id" v-model="_value" :readonly="isReadonly(item)" :form-data="_value"
          :mode="mode" :config="item" />
      </div>
    </el-form>
    <div v-else class="process-form" ref="form">
      <div :class="{ readonly: isReadonly(item) }" v-if="showItem(item)" v-for="(item, index) in forms"
        :key="item.name + index">
        <form-item v-if="item.name !== 'SpanLayout' && item.name !== 'Description'" :model="_value"
          :rule="rules[item.id]" :ref="item.id" :prop="item.id" :label="item.title">
          <form-design-render :readonly="isReadonly(item)" :formData="_value" :ref="item.id + '_item'"
            v-model="_value[item.id]" :mode="mode" :config="item" @loadings="handleLoading" />
        </form-item>
        <form-design-render :ref="item.id" :readonly="isReadonly(item)" :formData="_value" v-else v-model="_value"
          :mode="mode" :config="item" @loadings="handleLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Form } from "vant";
import { CompareFuncs } from "./components/compare/CompareOptions";
import FormItem from "@/components/common/FormItem";
import FormDesignRender from "@/views/admin/layout/form/FormDesignRender";
import { getPayWay, getPart, getArea, getFault, getServiceItem } from "@/api/design";
import { getItem, getLocationList} from '@/api/ops/conService'

const VForm = Form;
export default {
  name: "FormRender",
  components: { FormItem, FormDesignRender, VForm, Field },
  props: {
    resultTableList: {
      type: String,
      default: null
    },
    forms: {
      type: Array,
      default: () => {
        return [];
      },
    },
    config: {
      type: Object,
      default: () => {
        return {
          ruleType: "SIMPLE",
          rules: [],
        };
      },
    },
    process: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: null
    },
    //当前节点，用来联动表单权限
    currentNode: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mode: {
      type: String,
      default: "PC",
    },
  },
  data() {
    return {
      changeList: [],
      perm: 'R',
      formRules: {},
      //缓存下原始权限设置
      formPermHis: {},
      compareFunc: {},
      //缓存旧值
      oldFormData: {},
      //缓存所有用到的条件字段
      conditionFields: new Set(),
      execute: null,
    };
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    rules() {
      let rules = {};
      this.loadFormConfig(this.forms, rules);
      return rules;
    },
    formItemMap() {
      const map = new Map();
      this.loadFormItemMap(this.forms, map);
      return map;
    },
  },
  mounted() {
    // 如果有业务明细表单，判断表单权限
    if (this.formItemMap.get('fieldlistM')) {
      this.perm = this.formItemMap.get('fieldlistM').perm
      this.$emit('data-ready', this.perm)
    }
    this.updateRules()
    this.updateConServiceItemOptions(this._value);
  },
  created() {
    this.formItemMap.forEach((value, key) => {
      if (value.name == "SelectInput" && value.props.opts.length != 1) {
        this.handleChange(value.props.opts, key);
      }
      if (value.name == "SelectInput" && value.props.opts.length == 1) {
        // 如果有其他项的props.parent的值为key,则把key存入数组
        const hasChild1 = Array.from(this.formItemMap.values()).some(item =>
          item.name === 'ConServiceItemInput' && item.props.parent === key
        );
        if (hasChild1) {
          this.changeList.push(key);
        }
        const hasChild2 = Array.from(this.formItemMap.values()).some(item =>
          item.name === 'EngServiceItemInput' && item.props.parent === key
        );
        if (hasChild2) {
          this.changeList.push(key);
        }
      }
      if (value.name == 'PositionAreaInput') {
        this.getPositionAreaInput(value, key)
      }
    });
    this.getCustomize(this.formItemMap)
    this.setData(this.formItemMap)
  },
  methods: {
    updateRules() {
      // 清空现有规则
      this.rules = {};
      /// 使用 $nextTick 确保 DOM 更新
      this.$nextTick(() => {
        // 重新加载规则
        this.loadFormConfig(this._forms, this.rules);
        // 强制刷新表单组件
        this.$forceUpdate();
        // 如果有表单引用，也刷新表单
        if (this.$refs.form) {
          this.$refs.form.$forceUpdate();
        }
      });
    },
    getPositionAreaInput(item, key) {
      getLocationList(item.props.type).then(res => {
        // 更新 formItemMap 中的数据
        const targetItem = this.formItemMap.get(key);
        if (targetItem && targetItem.props) {
          this.$set(targetItem.props, 'options', res.data.data);
        }
        this._formsDirty = true;
        // 强制更新视图
        this.$nextTick(() => {
          this.$forceUpdate();
        })
      })
    },
    setData(formItemMap, rKey) {
      if (formItemMap instanceof Map) {
        formItemMap.forEach((value, key) => {
          this.setArray(value)
          if (value.name == 'SpanLayout') {
            value.props.items.forEach(item => {
              this.setArray(item)
            })
          }
          if ((value.name == 'SelectInput' && value.props.opts.length != 1) || value.name == 'PayInput') {
            this.handleChange(value.props.opts, key)
          }
          if (value.name == 'TableList') {
            this.setData(value.props.columns, key)
          }
          if (value.name == 'ConServiceItemInput') {
            this.handleChangeServiceItem(value.props.parent, key, "1")
          }
          if (value.name == 'EngServiceItemInput') {
            this.handleChangeServiceItem(value.props.parent, key, "2")
          }
        })
      } else if (formItemMap instanceof Array) {
        for (let i = 0; i < formItemMap.length; i++) {
          if (formItemMap[i].name == 'SystemTypeInput' && rKey != undefined) {
              this.handleChangeSystem(formItemMap[i].props.options, formItemMap[i].id, rKey)
            }
        }
      }
    },
    // 更新 ConServiceItemInput 组件选项
    updateConServiceItemOptions(formData) {
      this.formItemMap.forEach((item, key) => {
        // 检查父组件的值是否发生变化
        const parentValue = formData[item.props.parent];
        if (item.name === 'ConServiceItemInput' && item.props.parent && parentValue) {
          // 调用 API 更新选项
          this.handleChangeServiceItem(parentValue, key, "1");
        } else if (item.name === 'ConServiceItemInput') {
          // 如果没有父组件值，查出所有服务项目
          getItem(null, "1").then(res => {
            this.formItemMap.get(key).props.option = res.data
            // 同步更新 _forms 数组中的对应项
            this.forms.forEach(form => {
                if (form.id === item.id && form.props) {
                  this.$set(form.props, 'option', res.data);
                }
              });
              this.$forceUpdate();
          });
        }
        if (item.name === 'EngServiceItemInput' && item.props.parent && parentValue) {
          // 调用 API 更新选项
          this.handleChangeServiceItem(parentValue, key, "2");
        } else if (item.name === 'EngServiceItemInput') {
          // 如果没有父组件值，查出所有服务项目
          getItem(null, "2").then(res => {
            this.formItemMap.get(key).props.option = res.data
            // 同步更新 _forms 数组中的对应项
            this.forms.forEach(form => {
                if (form.id === item.id && form.props) {
                  this.$set(form.props, 'option', res.data);
                }
              });
              this.$forceUpdate();
          });
        }
      });
    },
    handleChangeServiceItem(m, type) {
      if (typeof m === 'string') {
        // 如果 m 是字符串，我们假设它应该被作为键，值为 undefined 或空字符串
        const tempMap = new Map();
        tempMap.set(m, undefined);
        m = tempMap;
      }
      if (m) {
        m.forEach((v, k) => {
          if (v != undefined) {
            // 找到props.parent = k 的项
            const items = Array.from(this.formItemMap.values()).filter(i => i.props && i.props.parent === k);
            if (items.length > 0) {
              items.forEach(item => {
                getItem(v, "1").then(res => {
                  if (this.formItemMap.get(item.id).name == 'ConServiceItemInput') {
                    this.$set(this.formItemMap.get(item.id).props, 'option', res.data);
                  }
                  // 同步更新 _forms 数组中的对应项
                  this.forms.forEach(form => {
                    if (form.id === item.id && form.props && form.name == 'ConServiceItemInput') {
                      this.$set(form.props, 'option', res.data);
                    }
                  });
                  this.$nextTick(() => {
                    this.$forceUpdate();
                  })
                });
                getItem(v, "2").then(res => {
                  if (this.formItemMap.get(item.id).name == 'EngServiceItemInput') {
                    this.$set(this.formItemMap.get(item.id).props, 'option', res.data);
                  }
                  // 同步更新 _forms 数组中的对应项
                  this.forms.forEach(form => {
                    if (form.id === item.id && form.props && form.name == 'EngServiceItemInput') {
                      this.$set(form.props, 'option', res.data);
                    }
                  });
                  this.$nextTick(() => {
                    this.$forceUpdate();
                  })
                });
              });
            }
          }
        })
      }
    },
    setArray(item) {
      if (!this.$route.name == 'design' && !this.$route.name == 'forms') {
        if (item.name == 'DateTimeRange' || item.name == 'DeptPicker' || item.name == 'EditorInput'
            || item.name == 'FileUpload' || item.name == 'ImageUpload' || item.name == 'MultipleSelect'
            || item.name == 'OrgPicker' || item.name == 'ProcessIndex' || item.name == 'SelectPlus'
            || item.name == 'TableList' || item.name == 'TimeRangePicker') {
          this._value[item.id] = []
        }
      }
    },
    getCustomize(map) {
      // TODO tableList内的输入框无法赋值
      map.forEach(item => {
        if (this.type == null && (item.perm == 'R' || item.perm == 'H')) {
          // 只有在可编辑状态下，去获取。只读或隐藏时直接返回
          return
        }
        if (item.name == 'TableList') {
          this.getCustomize(item.props.columns)
        } else if (item.name == 'TextInput') {
          if (item.props.customize && item.props.customize.id != null) {
            if (item.props.fieldId == null) {
              // 当前用户数据
              this._value[item.id] = this.$store.state.loginUser[item.props.customize.id]
            } else {
              // 根据表单内容变化，需要去获取数据。在监听时间内处理
              // this._value[item.id] = this._value[item.props.fieldId][0][item.props.customize.id] || a[item.props.customize.id]
              if (this._value[item.props.fieldId] && this._value[item.props.fieldId][0] && this._value[item.props.fieldId][0][item.props.customize.id] !== undefined) {
                this._value[item.id] = this._value[item.props.fieldId][0][item.props.customize.id];
              } else if (this.formItemMap.get(item.props.fieldId).props && this.formItemMap.get(item.props.fieldId).props.list !== undefined) {
                const a = this.formItemMap.get(item.props.fieldId).props.list.find(ele => ele.storeName || ele.areaName || ele.partitionName == this._value[item.props.fieldId])
                this._value[item.id] = a[item.props.customize.id];
              } else {
                // 可选：设置默认值或抛出错误
                this._value[item.id] = null; // 或其他默认值
              }
            }
          }
        }
      })
    },
    handleChange(e, key) {
      this.formItemMap.get(key).props.options = []
      this.formItemMap.get(key).props.opts = e
      if (this.formItemMap.get(key).name == 'PayInput' || e[e.length - 1] == '4') {
        getPayWay().then(res => {
          this.formItemMap.get(key).props.options = res.data;
        });
      } else if (e[e.length - 1] == '5') {
        getPart().then(res => {
          this.formItemMap.get(key).props.options = res.data.map(item => item.partName);
          this.formItemMap.get(key).props.list = res.data
        });
      } else if (e[e.length - 1] == '6') {
        getArea().then(res => {
          this.formItemMap.get(key).props.options = res.data.map(item => item.areaName);
          this.formItemMap.get(key).props.list = res.data
        });
      } else if (e[e.length - 1] == '7') {
        getFault().then(res => {
          this.formItemMap.get(key).props.options = res.data.map(item => item.faultName);
          this.formItemMap.get(key).props.list = res.data
        });
      } else if (this.formItemMap.get(key).name == 'ServiceItemInput') {
        getServiceItem().then(res => {
        const result = []
        res.data.forEach(item => {
          let categoryItem = result.find(cat => cat.value === item.category);
          if (!categoryItem) {
            categoryItem = { label: item.category, value: item.category, children: [] };
            result.push(categoryItem);
          }

          // 按 mainCategoryCode 字段进行分类
          let mainCategoryItem = categoryItem.children.find(mainCat => mainCat.value === item.mainCategoryCode);
          if (!mainCategoryItem) {
            mainCategoryItem = { label: item.mainCategoryName, value: item.mainCategoryCode, children: [] };
            categoryItem.children.push(mainCategoryItem);
          }

          // 按 categoryCode 字段进行分类
          let categoryCodeItem = mainCategoryItem.children.find(catCode => catCode.value === item.categoryCode);
          if (!categoryCodeItem) {
            categoryCodeItem = { label: item.categoryName, value: item.categoryCode, children: [] };
            mainCategoryItem.children.push(categoryCodeItem);
          }
          // 处理 description 字段
          if (item.description != null) {
            const descriptions = item.description.split(/[，。\n]/).filter(desc => desc.trim() !== '');
            descriptions.forEach(desc => {
              if (!categoryCodeItem.children.includes(desc)) {
                categoryCodeItem.children.push({
                  value: {value: item.opsType, label: desc},
                  label: desc
                });
              }
            });
          }
        });
        this.formItemMap.get(key).props.options = result;
      });
      }
    },
    showItem(item) {
      if (item.perm == 'E') return true
      else if (this.$route.name =='design') {
        return ((!this.isReadonly(item))
            || item.name === 'SpanLayout') &&
          item.perm !== 'H'
      } else {
        return (this.isReadonly(item) || item.name === 'SpanLayout') &&
          item.perm !== 'H'
      }
    },
    isBlank(val) {
      return (
        !this.$isNotEmpty(val) ||
        (val instanceof String && val.trim() === "") ||
        (Array.isArray(val) && val.length === 0)
      );
    },
    isReadonly1(item, val) {
      // console.log(item,val) val.length>0 看看默认
      if (val && val.length > 0 && item.perm == "R") {
        val.forEach((e, i) => {
          if (JSON.stringify(e) == '{}') {
            val.splice(i, 1)
          }
        })
      }
      return item.perm === 'R'
    },
    isReadonly(item) {
      if (item.perm === 'E') {
        if (this.$route.path == '/workspace/finished' || this.$route.path == '/workspace/cross/finished') {
          return true
        } else {
          return false
        }
      }
      return item.perm === 'R'
    },
    validate(call) {
      let validateResult = []
      if (this.forms.length == 0) validateResult.push(new Promise((resolve) => {
        resolve(true)
        return
      }))
      if (this.mode === 'PC') {
        this.$refs.form.validate(valid => {
          if (valid) {
            //校验成功再校验内部
            for (let i = 0; i < this.forms.length; i++) {
              validateResult.push(new Promise((resolve) => {
                  if (
                    (this.forms[i].name === "TableList" ||
                      this.forms[i].name === "OuterForm")
                      && this.forms[i].props.required && this.forms[i].perm !== 'H') {
                  let formRef = this.$refs[this.forms[i].id]
                  if (formRef && Array.isArray(formRef) && formRef.length > 0) {
                    formRef[0].validate(resolve)
                  } else {
                    resolve(true)
                  }
                  } else {
                    resolve(true);
                  }
                })
              );
            }
          } else {
            call(valid)
          }
        });
      } else {
        this.forms.forEach(form => {
          validateResult.push(new Promise((resolve) => {
            let formRef = this.$refs[form.id]

            // 只读或非必填的字段跳过校验
            if (form.perm === 'R' || !form.props.required) {
              resolve(true);
              return;
            }

              if (
                form.perm !== "H" &&
                formRef &&
                Array.isArray(formRef) &&
                formRef.length > 0
              ) {
                if (form.props.required || form.name === "SpanLayout") {
                  if (form.name === "TableList" || form.name === "OuterForm") {
                    //表格等组件先校验再校验内部列
                    new Promise((res) => {
                      formRef[0].validate(res);
                    }).then((rs) => {
                      if (rs) {
                        this.$refs[form.id + "_item"][0].validate(resolve);
                      }
                    });
                  } else {
                    formRef[0].validate(resolve);
                  }
                } else {
                  resolve(true);
                }
              } else {
                resolve(true);
              }
            })
          );
        });
      }
      if (validateResult.length > 0) {
        Promise.all(validateResult).then((results) => {
          // 检查结果数组中所有校验都成功为true
          const isSuccess = results.every((valid) => valid === true);
          if (isSuccess) {
            this.formRuleValid(call)
          }else {
            call(false)
          }
        })
      }
    },
    formRuleValid(call) {
      if (this.config.validConfig && this.$isNotEmpty(this.config.validConfig.js)) {
        console.log('前置规则校验')
        //如果有设置校验，就执行
        if (!this.validFunc) {
          this.validFunc = new Function('ctx', 'resolve', 'reject', this.config.validConfig.js)
        }
        //TODO 表单校验上下文变量，这里可以自己注入需要的字段，默认只有表单数据
        const ctx = { ...this._value }
        new Promise((resolve, reject) => {
          this.validFunc(ctx, resolve, reject)
        }).then(() => call(true)).catch(err => {
          call(false)
          this.$message.warning(err || '表单规则校验失败，请检查参数')
        })
      } else {
        call(true)
      }
    },
    loadFormItemMap(forms, map) {
      forms.forEach((item) => {
        if (item.name === "TableList") {
          map.set(item.id, item);
          this.loadFormItemMap(item.props.columns, map);
        } else if (item.name === "SpanLayout") {
          this.loadFormItemMap(item.props.items, map);
        } else {
          map.set(item.id, item);
        }
      });
    },
    loadFormConfig(forms, rules) {
      setTimeout(() => {
        if (rules.field5017665847262) {
          this.$set(rules, 'field5017665847262', [
            { required: true, message: '请评分', trigger: 'change' },
            { type: 'number', min: 0.5, max: 5, message: '评分必须在半星到5星之间', trigger: 'change' }
          ])
        }
      }, 1000)
      if (Array.isArray(forms)) {
        forms.forEach((item) => {
          if (item.name === 'SpanLayout') {
            this.loadFormConfig(item.props.items, rules)
          } else if (item.name === 'TableList') {
            this.loadFormConfig(item.props.columns, rules)
          } else {
            this.$set(this._value, item.id, this.value[item.id])
            if (item.props.required && this.showItem(item) && item.name !== 'OuterForm' && !this.isReadonly(item)) {
              this.$set(rules, item.id, [{
                type: item.valueType === 'Array' ? 'array' : undefined,
                required: true,
                message: `请完成${item.title}`, trigger: 'blur'
              }])
            }
          }
        })
      }
    },
    //解析表单联动规则
    parserRule(cdRule) {
      const condition = cdRule.condition;
      //在这里可以实现一个算法，按条件层级去解析，不需要解析所有条件，先不实现
      if (cdRule.children.length > 0) {
        for (let i = 0; i < cdRule.children.length; i++) {
          const result = this.parserRule(cdRule.children[i]);
          if (cdRule.logic) {
            //如果是且关系，有一个为假就是假
            if (!result) {
              return false;
            }
          } else {
            //如果是或关系，有一个为真就是真
            if (result) {
              return true;
            }
          }
        }
        //遍历完了返回最终结果
        return cdRule.logic;
      } else {
        //解析条件
        try {
          return this.compare(condition);
        } catch (e) {
          return false;
        }
      }
    },
    async doActions(actions) {
      (actions || []).forEach((action) => {
        //执行预设的动作
        switch (action.type) {
          case "SHOW":
            action.targets.forEach((tg) => this.showField(tg));
            break;
          case "HIDE":
            action.targets.forEach((tg) => this.hideField(tg));
            break;
          case "DISABLE":
            action.targets.forEach((tg) => this.disableField(tg));
            break;
          case "UPDATE":
            action.targets.forEach((tg) => this.updateField(tg, action.value));
            break;
          case "ENABLE":
            action.targets.forEach((tg) => this.enableField(tg, action.value));
            break;
        }
      });
    },
    analyseFormRule() {
if (this.config.ruleType === "SIMPLE") {
        this.analyseRules();
      } else {
        this.analyseJsRules();
      }
      // 规则分析完成后更新验证规则
      this.$nextTick(() => {
        this.updateRules();
      });
    },
    async analyseJsRules() {
      if (!(this.execute instanceof Function)) {
        this.execute = new Function(
          "formData",
          "formMap",
          `${this.config.ruleJs || "function doChange(){}"
          }\r\n doChange(formData, formMap);`
        );
      }
      this.execute(this.value, this.formItemMap);
      this.refreshKey++; // 强制重新渲染
    },
    async analyseRules() {
      (this.config.rules || []).forEach((rule, i) => {
        //解析表单联动条件
        const result = this.parserRule(rule.condition);
        console.log(`解析规则 ${i + 1}: ${result}`);
        this.doActions(result ? rule.action.with : rule.action.other);
      });
    },
    compare(condition) {
      //要判断组件类型，再取其值
      const source = this._value[condition.field];
      //动态调用函数
      let compareType = null;
      switch (condition.fieldType) {
        case "AmountInput":
        case "NumberInput":
        case "Score":
        case "CalcFormula":
          compareType = "numCompare";
          break;
        case "TextInput":
        case "TextareaInput":
        case "SelectInput":
        case "Location":
        case "Provinces":
          compareType = "strCompare";
          break;
        case "MultipleSelect":
          compareType = "strArrCompare";
          break;
        case "DateTime":
          compareType = "timeCompare";
          break;
        case "DateTimeRange":
          compareType = "timeArrCompare";
          break;
        case "DeptPicker":
        case "UserPicker":
          compareType = "orgCompare";
          break;
      }
      return CompareFuncs[compareType][condition.compare](
        source,
        condition.fixed
          ? condition.compareVal
          : this._value[condition.compareVal[0]]
      );
    },
    isRequired(item) {
      return this.rules[item.id] !== undefined && !this.isReadonly(item)
    },
    hideField(id) {
      const field = this.formItemMap.get(id);
      if (field) {
        this.$set(field, "perm", "H");
      }
    },
    handleLoading(e) {
      this.$emit("loadings", e);
      this.$forceUpdate()
    },
    showField(id) {
      const field = this.formItemMap.get(id);
      if (field) {
        this.$set(field, "perm", this.formPermHis[id] || "E");
      }
    },
    disableField(id) {
      const field = this.formItemMap.get(id);
      if (field) {
        this.$set(field, "perm", "R");
      }
    },
    enableField(id) {
      const field = this.formItemMap.get(id);
      if (field) {
        this.$set(field, "perm", "E");
      }
    },
    updateField(id, val) {
      const field = this.formItemMap.get(id);
      if (field) {
        this._value[id] = val;
      }
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        // 找出changeLsit中的key值
        const m = new Map();
        for (let i = 0; i < this.changeList.length; i++) {
          m.set(this.changeList[i], this.value[this.changeList[i]])
        }
        if (m.size > 0) {
          this.handleChangeServiceItem(m)
        }
        // if (this.formItemMap.get())
        // 不记得为什么在表单预览中终止规则判断,先注掉,有问题再改
        // if (this.$route.name == 'design') return
        if (this.config) {
          if (Object.keys(this.formPermHis).length === 0 || Object.values(this.formPermHis).every(item => !item)) {
            this.formItemMap.forEach((item) => {
              this.formPermHis[item.id] = item.perm;
            });
          }
          this.analyseFormRule();
        }
        this.getCustomize(this.formItemMap)
        // 重置_forms脏标记
        this._formsDirty = false;
      }
    },
    // 监听 formItemMap 的变化
    formItemMap: {
      handler() {
        this.updateRules();
        this.$forceUpdate()
      },
      deep: true
    }
  },
};
</script>

<style lang="less" scoped>
.process-form {
  /deep/ .el-form-item__label {
    height: 30px;
    line-height: 30px;
    padding: 0 0;
  }

  /deep/ .van-radio__icon--checked .van-icon {
    background-color: #006c50;
    border-color: #006c50;
  }

  /deep/ .van-cell {
    padding: 10px 0;
    font-size: 1.2rem;
  }
}

/deep/ .readonly {
  font-size: 16px;

  .el-form-item {
    margin-bottom: 10px;

    .el-form-item__label {
      font-weight: bold; /* 设置字体加粗 */
      font-size: 16px;
      color: black;
    }
    .el-form-item__label::before {
      display: none;
    }

    .el-form-item__content {
      padding-left: 5px;
      line-height: 30px;
    }
  }

  .m-form-item {
    padding: 10px 5px;
    margin-bottom: 0;

    .m-form-item_title {
      font-size: 1.3rem;

      .title-required {
        display: none;
      }
    }

    .m-form-item_content {
      padding-left: 4px;
      font-size: 1.4rem;
    }
  }
}
</style>
